<div class="container" style="padding-top: 1%">
  <h2>Modificare Produs</h2>
</div>
<div class="container" style="padding-top: 2%">
  <form #editProductForm="ngForm" (ngSubmit)="saveProduct(editProductForm)" (keydown.enter)="$event.preventDefault()"
        [formGroup]="productsForm">
    <div class="form-group row">
      <label for="vendor" class="col-sm-2 col-form-label">Vendor</label>
      <div class="col-sm-4">
        <input name="Vendor" [ngClass]="{'is-invalid' : productsForm.controls.Vendor.invalid}" formControlName="Vendor"
               class="form-control" id="vendor">
        <p *ngIf="productsForm.controls.Vendor.invalid" style="margin-top: 7px; font-size: 12px" class="text-danger">
          Câmpul este obligatoriu!</p>
      </div>
      <label for="partNo" class="col-sm-2 col-form-label">Part Number</label>
      <div class="col-sm-4">
        <input name="PartNo" [ngClass]="{'is-invalid' : productsForm.controls.PartNo.invalid}" formControlName="PartNo"
               class="form-control" id="partNo">
        <p *ngIf="productsForm.controls.PartNo.invalid" style="margin-top: 7px; font-size: 12px" class="text-danger">
          Câmpul este obligatoriu!</p>
      </div>

    </div>

    <div class="form-group row">
      <label for="hsCode" class="col-sm-2 col-form-label">HS Code</label>
      <div class="col-sm-4">
        <input name="HsCode" [ngClass]="{'is-invalid' : productsForm.controls.HsCode.invalid}" formControlName="HsCode"
               class="form-control" id="hsCode">
        <p *ngIf="productsForm.controls.HsCode.errors?.required" style="margin-top: 7px; font-size: 12px"
           class="text-danger">Câmpul este obligatoriu!</p>
        <p *ngIf="productsForm.controls.HsCode.errors?.pattern && !productsForm.controls.HsCode.errors?.required"
           style="margin-top: 7px; font-size: 12px" class="text-danger">Formatul codului nu este corect!</p>
      </div>

      <label for="eccn" class="col-sm-2 col-form-label">ECCN</label>
      <div class="col-sm-4">
        <input name="Eccn" [ngClass]="{'is-invalid' : productsForm.controls.Eccn.invalid}" formControlName="Eccn"
               class="form-control" id="eccn">
        <p *ngIf="productsForm.controls.Eccn.errors?.required" style="margin-top: 7px; font-size: 12px"
           class="text-danger">Câmpul este obligatoriu!</p>
        <p *ngIf="productsForm.controls.Eccn.errors?.pattern && !productsForm.controls.Eccn.errors?.required"
           style="margin-top: 7px; font-size: 12px" class="text-danger">Formatul codului nu este corect!</p>
      </div>

    </div>

    <div class="form-group row">
      <label for="categorieTimbruVerde" class="col-sm-2 col-form-label">Categorie Timbru Verde</label>
      <div class="col-sm-10">
        <select name="CategorieTimbruVerde" ngModel
                [ngClass]="{'is-invalid' : productsForm.controls.CategorieTimbruVerde.invalid}"
                formControlName="CategorieTimbruVerde" class="form-control" id="categorieTimbruVerde">
          <option value="{{product.CategorieTimbruVerde}}" selected>{{product.CategorieTimbruVerde}}</option>
          <option *ngFor="let greenstamp of greenstamps">{{greenstamp}}</option>
        </select>
        <p *ngIf="productsForm.controls.CategorieTimbruVerde.errors?.required" style="margin-top: 7px; font-size: 12px"
           class="text-danger">Câmpul este obligatoriu!</p>
      </div>
    </div>
    <div class="form-group row">
      <label for="taraOrigine" class="col-sm-2 col-form-label">Țară de origine</label>
      <div class="col-sm-4">
        <select name="TaraOrigine" ngModel [ngClass]="{'is-invalid' : productsForm.controls.TaraOrigine.invalid}"
                formControlName="TaraOrigine" class="form-control" id="taraOrigine">
          <option value="{{product.TaraOrigine}}" selected>{{product.TaraOrigine}}</option>
          <option *ngFor="let country of countries">{{country}}</option>
        </select>
        <p *ngIf="productsForm.controls.TaraOrigine.errors?.required" style="margin-top: 7px; font-size: 12px"
           class="text-danger">Câmpul este obligatoriu!</p>
      </div>

      <label for="piese" class="col-sm-2 col-form-label">Piese</label>
      <button type="button" id="piese" class="btn btn-outline-info col-sm-4" (click)="modifyParts(modalParts)" style="height: 40px;">Modificare listă piese <i
        class="far fa-edit"></i></button>

    </div>

    <div class="row">
      <button class="btn btn-warning" style="margin: 1%" (click)="cancelEditProduct()"><i
        class="far fa-times-circle"></i> Anulare
      </button>
      <button
        *ngIf="!productsForm.controls.Vendor.invalid && !productsForm.controls.PartNo.invalid && !productsForm.controls.HsCode.invalid && !productsForm.controls.Eccn.invalid && !productsForm.controls.TaraOrigine.invalid && !productsForm.controls.CategorieTimbruVerde.invalid"
        type="submit" class="btn btn-success" style="margin: 1%">
        <i class="far fa-save"></i> Salvare
      </button>
      <button
        *ngIf="productsForm.controls.Vendor.invalid || productsForm.controls.PartNo.invalid || productsForm.controls.HsCode.invalid || productsForm.controls.Eccn.invalid || productsForm.controls.TaraOrigine.invalid || productsForm.controls.CategorieTimbruVerde.invalid"
        class="btn btn-success disabled" style="margin: 1%" disabled>
        <i class="far fa-save"></i> Salvare
      </button>
    </div>
  </form>

</div>

<ng-template #modalParts let-modalParts>
  <div class="modal-header">
    <h4 class="modal-title">Modificare listă piese</h4>
  </div>
  <div class="modal-body">
    <table class="table table-responsive">
      <thead>
      <tr>
        <th scope="col" style="width: 35%; font-size: small">
          Nume
        </th>
        <th scope="col" style="width: 15%">

        </th>
      </tr>
      </thead>
      <tbody>
      <tr style="margin: 1%">
        <th>
          <input style="margin: 1%" type="text" class="form-control" [(ngModel)]=currentPartName (keyup.enter)="addPart()">
        </th>
        <th>
          <button style="margin: 1%" class="btn btn-outline-success" (click)="addPart()">Adăugare <i class="bi bi-plus-lg"></i></button>
        </th>
      </tr>
      <tr *ngFor="let part of getParts()" style="margin: 1%">
        <th style="font-weight:normal;">
          {{part}}
        </th>
        <th style="">
          <button
            type="button" class="btn btn-outline-danger" (click)="deletePart(part)" style="margin: 1%">Șterge <i
            class="bi bi-trash"></i>
          </button>
        </th>
      </tr>
      </tbody>
    </table>
    <div *ngIf="numberOfPartPages > 1" class="row">
      <button class="btn btn-info" style="margin: 2px" type="button" (click)="goToPrevPage()"><i
        class="bi bi-chevron-left"></i></button>
      <div style="margin: 4px; font-size: 19px">{{currentPartPage}} / {{numberOfPartPages}}</div>
      <button class="btn btn-info" style="margin: 2px" type="button" (click)="goToNextPage()"><i
        class="bi bi-chevron-right"></i></button>
    </div>


  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="applyPartsModifications(modalParts)"><i
      class="bi bi-check-lg"></i> Aplicare
    </button>
  </div>
</ng-template>
